import React from 'react';

const PromptGenAiFormModal = React.lazy(() => import('../components/FormModal'));
const promptGenAiModalRegistry = {
    company_promptGenAiId: PromptGenAiFormModal
};
export default promptGenAiModalRegistry;
